export const RENDERER_ANNOTATION_PROVIDER_SSR_FF =
	'confluence.ssr.renderer.annotation.provider.inline.comments';
